/**
 *
 * @param events
 * @returns {{onBlur: null, onChange: null}}
 */
export function checkEvents(events = []) {
    const currentEvents = {
        onChange: null,
        onBlur: null
    };
    //subscribe to events
    if (events.length) {
        for (let event of events) {
            currentEvents[event.event] = event.actions
        }
    }

    return currentEvents
}